const baseApi = 'https://school-management-system-backend-m45s.onrender.com/api';
// const baseApi='http://localhost:5000/api'

export {baseApi}